import { Entity, IHasKey } from '@kpd/framework-ngx';
import { PermissionsetKey } from './keys/permissionset-key';
import { IPermissionSetDTO, IPermissionSetDetailDTO } from 'app/shared/services/permissionset.service';
import { Permission } from 'app/shared/models/permission';
import { currentLanguage, languageMap } from '@kpd/framework-ngx';

export class Permissionset extends Entity implements IHasKey {
  key: PermissionsetKey;
  name: string;
  description: {
    dutch?: string;
    english?: string;
    french?: string;
    german?: string;
  };
  permissions?: Permission[];
  permissionIds?: string[] = [];
  application?: string;
  type?: string;
  translatedDescription: string;
  scope: string;
  isGlobal = false;

  constructor(dto?: IPermissionSetDTO | IPermissionSetDetailDTO, application?: string) {
    super();
    Object.assign(this, dto);
    this.application = application;
    if (this.isKpdSet || this.type === 'template') {
      this.isGlobal = true;
    }
    if (dto && dto.permissions) {
      this.permissions = dto.permissions.map((permissionDTO) => new Permission(permissionDTO));
    }
    if (dto) {
      this.setKey();
    }
    if (typeof this.description === 'object') {
      this.translatedDescription = this.description[languageMap[currentLanguage]];
    } else this.translatedDescription = this.description;
  }

  getDisplayName(): string {
    return this.name || '';
  }

  setKey(): void {
    this.key = new PermissionsetKey(this.name, this.application || '', this.isGlobal);
  }

  clone(): Permissionset {
    const clone = new Permissionset();
    Object.assign(clone, this);
    return clone;
  }

  isNew(): boolean {
    return !this.key;
  }

  get isKpdSet(): boolean {
    return this.scope === 'global' && this.type !== 'template';
  }
}
